import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-a01-carousel" }
const _hoisted_2 = {
  key: 0,
  class: "p-the-a01-carousel__carousel c-swiper"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "p-the-a01-carousel__carousel"
}
const _hoisted_6 = { class: "p-the-a01-carousel__carousel__inner" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_AppSwiper = _resolveComponent("AppSwiper")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.useCarousel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AppSwiper, {
            ref: "mySwiper",
            class: "p-the-a01-carousel__carousel__inner",
            options: _ctx.swiperOption
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselItems, ({ image, url, banner_type, categories, premiums }, key) => {
                return (_openBlock(), _createBlock(_component_SwiperSlide, { key: key }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      href: _ctx.setUrl(banner_type, url, categories, premiums),
                      class: "p-the-a01-carousel__carousel__link"
                    }, [
                      _createElementVNode("img", {
                        class: "p-the-a01-carousel__carousel__image",
                        src: image,
                        alt: ""
                      }, null, 8, _hoisted_4)
                    ], 8, _hoisted_3)), [
                      [_directive_touch, void 0, "tap"]
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["options"]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "p-the-a01-carousel__carousel__pagination" }, null, -1))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              href: _ctx.carouselItems[0].url,
              class: "p-the-a01-carousel__carousel__link"
            }, [
              _createElementVNode("img", {
                class: "p-the-a01-carousel__carousel__image",
                src: _ctx.carouselItems[0].image,
                alt: ""
              }, null, 8, _hoisted_8)
            ], 8, _hoisted_7)
          ])
        ]))
  ]))
}